import axios from "axios";

export interface DocumentResp {
   createdAt: string;
   createdBy: {
      email: string;
      fullname: string;
      id: string;
      name: string;
      phone: string;
      utmCampaign: string | null;
      utmContent: string | null;
      utmMedium: string | null;
      utmSource: string | null;
   };
   createdById: string;
   id: string;
   name: string | null;
   isApproved: boolean | null;
   localeId: string | null;
   reviewedAt: string | null;
   reviewedBy: string | null;
   study: {
      id: string;
      key: string;
      title: string;
   };
   studyId: string | null;
   surveyId: string | null;
   surveyPageName: string | null;
   type: {
      adminUploadOnly: boolean;
      createdAt: string;
      description: string;
      id: string;
      label: string;
      name: string;
      requiresReview: boolean;
   };
   userProxyId: string;
   userProxy: {
      id: string;
      updatedAt: string;
      user: {
         email: string;
         fullname: string;
         id: string;
         name: string;
      };
      userId: string;
   };
}

interface FileInfo {
   filename: string;
   filesize: number;
   filetype: string;
}

interface File extends Blob {
   name: string;
}

interface BlockUploadResp {
   id: string;
   s3_url: string;
   filename: string;
   user_proxy_id: string;
   block_version_id: string;
}

interface BlockUploadsResp {
   data: BlockUploadResp[];
}

export default class DocumentsApi {
   public static getAll = async (): Promise<DocumentResp[]> => {
      const response = await axios.get(`/documents`);
      return response.data?.data;
   };

   public static getDocument = async (docID: string) => {
      const response = await axios.get(`/documents/${docID}/file`, {
         withCredentials: true,
         responseType: "blob",
         headers: { "X-Requested-With": "XMLHttpRequest" },
      } as any);

      return response;
   };

   public static getUploadPresignedURL = async (blockVersionId: string, fileInfo: FileInfo) => {
      const response = await (axios as any).post(
         `/block-versions/${blockVersionId}/s3-presigned-url-for-file-uploads`,
         fileInfo
      );

      return response;
   };

   public static uploadDocument = async (presignedUrl: string, selectedFile: File) => {
      // if successful, then try request to upload file to the location provided in request above (presigned url)
      // we create new axios instance to avoid default config
      // also explicitly set withCredentials to false
      // file location is set on the BE
      // server/domains/flows/rest/answers.py = aws bucket /sano-file-uploads/env/{user_id}/{block_id}/{filename}
      const axiosForUpload = axios.create({
         withCredentials: false,
      });

      return await axiosForUpload.put(presignedUrl, selectedFile);
   };

   // get uploaded documents for specific upload block
   public static getBlockUploads = async (blockVersionId: string): Promise<BlockUploadsResp> => {
      const response = await axios.get(`/block-versions/${blockVersionId}/uploads`);
      return response.data;
   };

   // delete uploaded documents for specific upload block
   // (can only be used when block is unsubmitted)
   public static deleteBlockUploads = async (blockVersionId: string) => {
      return await axios.delete(`/block-versions/${blockVersionId}/uploads`);
   };
}
